/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CategoryModalEdit from '../Modals/CategoryModalEdit'
import SubCategoryModalEdit from '../Modals/SubCategoryModalEdit'
import FaqModal from '../Modals/FaqModalEdit'
import FaqVideoEditModal from '../Modals/FaqVideoEditModal'
import MDTypography from 'components/MDTypography'

//
export default function DataTableData() {
  const AppService = useAppServices()
  const params = useParams()
  const navigate = useNavigate()
  const [faq, setFaq] = useState([])
  const [faqVideos, setFaqVideos] = useState([])
  const [categries, setCategries] = useState([])
  const [subcategories, setSubCategories] = useState([])
  const [loader, setloader] = useState(true)
console.log("FAQs :",)
  const getFaqs = async () => {
    const { response, error } = await AppService.faq_category.get({
      query: ``,
    })
    // console.log(response, 'response')
    if (response) {
      setCategries(response.data?.map((item) => ({ ...item, label: item.name, value: item._id })))
      setFaq(response.faq)
      setFaqVideos(response.faq_videos)
      setSubCategories(response.faq_subcategories?.map((item) => ({ ...item, label: item.name, value: item._id })))
      setloader(false)
    } else {
      setCategries([])
      setFaq([])
      setloader(false)
    }
  }
  console.log("Sub Categories: ", subcategories)
  const onLoad = () => {
    console.log("onLoad")
    getFaqs()
  }
  const CategoriesCell = ({ categories }) => {
    if (!categories) return <MDTypography variant="caption">N/A</MDTypography>;
    if (!Array.isArray(categories)) return <MDTypography variant="caption">{categories.name || 'N/A'}</MDTypography>;
    
    return (
      <MDBox display="flex" flexWrap="wrap" gap={0.5}>
        {categories?.map((cat, i) => (
          <MDTypography 
            key={i} 
            variant="caption" 
            color="text" 
            sx={{
              px: 1,
              py: 0.5,
              borderRadius: 0.5,
              bgcolor: 'grey.100',
              display: 'inline-block',
              mr: 0.5,
              mb: 0.5
            }}
          >
            {cat.name}
          </MDTypography>
        ))}
      </MDBox>
    );
  };
  
  const handleCategoryDelete = async (id) => {
    const { response } = await AppService.faq_category.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }
  const handleSubCategoryDelete = async (id) => {
    const { response } = await AppService.faq_subcategory.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }
  const handleFaqDelete = async (id) => {
    const { response } = await AppService.faq.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }
  useEffect(onLoad, [])
  return {
    loader: loader,
    categries: categries,
    subcategories: subcategories,
    handleRefresh: onLoad,
    CategoryDataTableData: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'status', accessor: 'status' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: categries?.map((data, index) => ({
        name: data.name,
        status: data.status,
        action: (
          <div className="d-flex">
            <CategoryModalEdit handleRefresh={onLoad} editData={data} />
            <MDBox>
              <MDButton
                variant="contained"
                color="error"
                size="small"
                sx={{ marginLeft: 2 }}
                onClick={() => handleCategoryDelete(data._id)}
              >
                Delete
              </MDButton>
            </MDBox>
          </div>
        ),
      })),
    },
    SubCategoryDataTableData: {
      columns: [
        { 
          Header: 'categories', 
          accessor: 'category',
          Cell: ({ value }) => <CategoriesCell categories={value} />,
          // Custom filter method for categories
          filterMethod: (filter, row) => {
            const subcategories = row.original.category;
            if (!subcategories) return false;
            if (Array.isArray(subcategories)) {
              return subcategories.some(cat => 
                cat.name.toLowerCase().includes(filter.value.toLowerCase())
              );
            }
            return subcategories.name.toLowerCase().includes(filter.value.toLowerCase());
          }
        },
        { Header: 'name', accessor: 'name' },
        { Header: 'status', accessor: 'status' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: subcategories?.map((data, index) => ({
        name: data.name,
        status: data.status,
        category: data.category,
        action: (
          <div className="d-flex">
            <SubCategoryModalEdit handleRefresh={onLoad} editData={data} />
            <MDBox>
              <MDButton
                variant="contained"
                color="error"
                size="small"
                sx={{ marginLeft: 2 }}
                onClick={() => handleSubCategoryDelete(data._id)}
              >
                Delete
              </MDButton>
            </MDBox>
          </div>
        ),
      })),
    },
    // Then update your table configuration in the component where you use DataTable
    FaqDataTableData: {

      columns: [
        { Header: 'question', accessor: 'question' },
        { 
          Header: 'categories', 
          accessor: 'category',
          Cell: ({ value }) => <CategoriesCell categories={value} />,
          // Custom filter method for categories
          filterMethod: (filter, row) => {
            const categories = row.original.category;
            if (!categories) return false;
            if (Array.isArray(categories)) {
              return categories.some(cat => 
                cat.name.toLowerCase().includes(filter.value.toLowerCase())
              );
            }
            return categories.name.toLowerCase().includes(filter.value.toLowerCase());
          }
        },
        { 
          Header: 'subcategories', 
          accessor: 'subcategory',
          Cell: ({ value }) => <CategoriesCell categories={value} />,
          // Custom filter method for categories
          filterMethod: (filter, row) => {
            const subcategories = row.original.subcategory;
            if (!subcategories) return false;
            if (Array.isArray(subcategories)) {
              return subcategories.some(cat => 
                cat.name.toLowerCase().includes(filter.value.toLowerCase())
              );
            }
            return subcategories.name.toLowerCase().includes(filter.value.toLowerCase());
          }
        },
        { Header: 'type', accessor: 'type' },
        { Header: 'status', accessor: 'status' },
        { Header: 'Action', accessor: 'action' },
      ],
    
      rows: faq?.map((data, index) => ({
        question: data.question,
        category: data.category,
        subcategory: data.subcategory,
        type: data.type,
        status: data.status,
        _id: data._id,
        action: (
          <MDBox display="flex" alignItems="center">
            <FaqModal categries={categries} handleRefresh={onLoad} editData={data} subcategories={subcategories}/>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleFaqDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
    FaqVideosDataTableData: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'url', accessor: 'url' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: faqVideos?.map((data, index) => ({
        name: data.name,
        url: data.url,
        action: (
          <MDBox>
            <FaqVideoEditModal categries={categries} handleRefresh={onLoad} editData={data} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleFaqDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
